import React from 'react';
import { motion } from 'framer-motion';
import { PrimaryButton, SecondaryButton } from './ui/UI';
import { Aurora } from './animations/Aurora';
import { BlurText } from './animations/BlurText';
import { DecryptedText } from './animations/DecryptedText';
import { ScrollFloat } from './animations/ScrollFloat';
import { Magnet } from './animations/Magnet';
import { RadarEcho } from './animations/RadarEcho';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative w-full py-40 border-t border-white/5 overflow-hidden" data-id="element-470">
      {/* Aurora wash for atmosphere */}
      <Aurora intensity={0.3} data-id="element-471" />

      {/* Background radar echo */}
      <RadarEcho intensity={0.2} data-id="element-472" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-473">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-474">
          <span className="inline-flex items-center justify-center gap-4 text-[#1a8fd4] text-[11px] font-mono uppercase tracking-[0.3em] mb-8" data-id="element-475">
            <span className="h-px w-10 bg-[#1a8fd4]/40" aria-hidden="true" data-id="element-476" />
            <DecryptedText text="Final" speed={50} data-id="element-477" />
            <span className="h-px w-10 bg-[#1a8fd4]/40" aria-hidden="true" data-id="element-478" />
          </span>

          {/* Headline with scroll-driven zoom */}
          <ScrollFloat scaleFrom={0.9} scaleTo={1} yFrom={30} data-id="element-479">
            <h2 className="text-5xl md:text-7xl lg:text-8xl font-semibold tracking-[-0.04em] leading-[0.95] text-white mb-8" data-id="element-480">
              Stop guessing.
              <br data-id="element-481" />
              <span className="text-white/40" data-id="element-482">Validate it.</span>
            </h2>
          </ScrollFloat>

          <p className="text-xl md:text-2xl text-white/70 max-w-2xl mx-auto mb-4" data-id="element-483">
            Periscan is coming back in 2026. Autonomous validation missions.
            Exposure validation. Control checks. Attack-path validation. AI app
            validation. Fix verification. Evidence packs. Self-service adoption.
          </p>

          <p className="font-mono text-base text-[#1a8fd4] mb-10" data-id="element-484">
            <DecryptedText text="Find the path. Validate the risk. Prove it's fixed." speed={30} data-id="element-485" />
          </p>

          {/* Dual CTAs — Request Early Access + Join the Team */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center" data-id="element-486">
            <Magnet strength={0.2} data-id="element-487">
              <a href="/early-access" className="group inline-flex items-center gap-3 px-7 py-4 bg-white text-black font-medium rounded-full text-base hover:bg-white/90 transition-colors" data-id="element-488">
                <span data-id="element-489">Request Early Access</span>
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" data-id="element-490" />
              </a>
            </Magnet>
            <Magnet strength={0.15} data-id="element-491">
              <a href="/jobs" className="group inline-flex items-center gap-3 px-7 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium rounded-full text-base transition-colors backdrop-blur-sm" data-id="element-492">
                <span data-id="element-493">Join the Team</span>
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-494" />
              </a>
            </Magnet>
          </div>

          <p className="mt-8 text-sm text-white/40 italic max-w-xl mx-auto" data-id="element-495">
            No spam. No "thought leadership" drip campaign disguised as a
            personality. Just early-access details when they're ready.
          </p>
        </motion.div>
      </div>
    </section>;
}